module.exports = __webpack_public_path__ + "1c66098f893de62d577c92e7dbb9535a.svg";